import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Phone, Mail, MapPin, MessageCircle, Clock, ShieldCheck } from "lucide-react";

export default function ContactPage() {
  const [wa, setWa] = useState("");

  useEffect(() => {
    api.get("/config").then((r) => {
      setWa((r?.data?.whatsapp_number || "").replace(/[^0-9]/g, ""));
    }).catch(() => {});
  }, []);

  const waUrl = wa
    ? `https://wa.me/${wa}?text=${encodeURIComponent("Hi! I'd like to know more about Hyderabad Crackers.")}`
    : null;

  return (
    <div data-testid="contact-page" className="px-4 py-6 max-w-3xl mx-auto">
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold flex items-center gap-2">
        <Phone className="w-6 h-6 text-hyd-gold" /> Contact us
      </h1>
      <p className="text-hyd-text2 mt-2 text-sm">
        We're a Sivakasi-direct seller delivering across Telangana &amp; Andhra Pradesh. Reach us for bulk orders, wholesale pricing, or any delivery questions.
      </p>

      <div className="mt-6 grid sm:grid-cols-2 gap-4">
        <Card icon={MessageCircle} title="WhatsApp" href={waUrl || undefined}>
          {wa ? `+${wa}` : "WhatsApp not configured"}
          {waUrl && <div className="text-[11px] text-emerald-500 mt-1 font-bold">Tap to chat →</div>}
        </Card>
        <Card icon={Phone} title="Call us" href={wa ? `tel:+${wa}` : undefined}>
          {wa ? `+${wa}` : "Phone not configured"}
          <div className="text-[11px] text-hyd-text3 mt-1">Mon – Sat, 10am – 8pm</div>
        </Card>
        <Card icon={Mail} title="Email" href="mailto:support@hyderabadcrackers.com">
          support@hyderabadcrackers.com
          <div className="text-[11px] text-hyd-text3 mt-1">We reply within 24 hours</div>
        </Card>
        <Card icon={MapPin} title="Warehouse">
          Hyderabad, Telangana &nbsp;500001
          <div className="text-[11px] text-hyd-text3 mt-1">Direct Sivakasi stock</div>
        </Card>
      </div>

      <div className="mt-6 bg-hyd-panel border border-hyd-border rounded-2xl p-4">
        <div className="text-[10px] uppercase tracking-widest text-hyd-gold font-bold flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> Delivery window</div>
        <div className="text-sm text-hyd-text mt-1">24–72 hours in Hyderabad · </div>
      </div>

      <div className="mt-3 bg-hyd-panel border border-hyd-border rounded-2xl p-4">
        <div className="text-[10px] uppercase tracking-widest text-hyd-gold font-bold flex items-center gap-1"><ShieldCheck className="w-3.5 h-3.5" /> Compliance</div>
        <div className="text-sm text-hyd-text mt-1">All crackers are PESO licensed. Age verification applies at checkout (18+).</div>
      </div>
    </div>
  );
}

function Card({ icon: Icon, title, href, children }) {
  const Inner = (
    <div className="bg-hyd-panel border border-hyd-border rounded-2xl p-4 hover:border-hyd-gold/50 transition-colors h-full">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-hyd-gold font-bold">
        <Icon className="w-3.5 h-3.5" /> {title}
      </div>
      <div className="text-sm text-hyd-text mt-1">{children}</div>
    </div>
  );
  return href ? <a href={href} target="_blank" rel="noreferrer" data-testid={`contact-${title.toLowerCase().replace(/\s/g,'-')}`}>{Inner}</a> : Inner;
}
